import { render, staticRenderFns } from "./PlayersProps.vue?vue&type=template&id=4caebf2e&"
import script from "./PlayersProps.vue?vue&type=script&lang=js&"
export * from "./PlayersProps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports